import styled from 'styled-components';
import Image from 'next/image';

import BREAKPOINTS from 'styles/breakpoints';
import { rem } from 'styles/typography';
import { P1 } from 'styles/typography';

const LogoTop = styled.section`
  position: absolute;
  width: 100px;
  height: 100px;
  z-index: 10;
  left: 0;
  right: 0;
  margin: auto;
  margin-top: -50px;

  ${BREAKPOINTS.small`
    width: 250px;
    height: 250px;
    margin-top: -125px;
    z-index: 10;
  `}
`;

const LogoBottom = styled.section`
  padding-top: 60px;
  padding-bottom: 10px;

  ${BREAKPOINTS.small`
    padding-top: 160px;
    padding-bottom: 50px;
  `}
`;

const PartnerHeading = styled.section`
  display: flex;
  justify-content: center;
  text-transform: uppercase;

  p {
    padding: 0 var(--gutter-side);
    text-align: center;
    line-height: ${rem(14)};
  }
`;

const PartnerLogo = styled.section`
  position: relative;
  width: 150px;
  height: 100px;
  margin: auto;

  ${BREAKPOINTS.small`
    margin-top: 40px;
    width: 180px;
    height: 80px;
  `}
`;

const WhatsOnPartnerLogos = ({ data }) => {
  return (
    <>
      <LogoTop>
        <Image src={data.logo?.url} alt={data.logo?.alt} layout="fill" />
      </LogoTop>

      <LogoBottom>
        <PartnerHeading>
          <P1 small weight="bold">
            {data.partnerTitle}
          </P1>
        </PartnerHeading>

        <PartnerLogo>
          <Image
            src={data.partnerLogo?.url}
            alt={data.partnerLogo?.alt}
            layout="fill"
            objectFit="contain"
          />
        </PartnerLogo>
      </LogoBottom>
    </>
  );
};

export default WhatsOnPartnerLogos;
